
<template>

  <div style="display:inline-table;line-height:10px;" v-bind:id="'user-icon-' + getId()">
    <canvas style="cursor:pointer;" @click="openModal" ref="canvas" v-bind:id="'user-icon-image-' + getId()" alt="" v-bind:width="size" v-bind:height="size"></canvas>
    <modal-in-front v-bind:title="map" ref="thisModal" size="modal-md" style="line-height:initial;">
      <div style="margin:auto;overflow:visible;position:relative">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <div class="card border-0 shadow-0">
                <div class="card-body text-center">
                  <div class="card-img-actions d-inline-block mb-3">
                    <canvas ref="canvas2" v-bind:id="'user-icon-image2-' + getId()" alt="" width="171" height="171"></canvas>
                  </div>
                  <h6 class="font-weight-semibold mb-0">{{fullName}}</h6>
                  <span class="d-block text-muted">{{email}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal-in-front>
  </div>
</template>

<script>

  import ModalInFront from "../modals/modal-in-front.vue";
  
  export default {
    name: 'user-detail-button',
    components: {
      ModalInFront
    },
    props: {
      username: {
        required: false,
        type: String,
        default: null
      },
      url: {
        required: false,
        type: String,
        default: null
      },
      bordercolor: {
        required: false,
        type: String,
        default: '#c7c7c7'
      },
      size: {
        required: false,
        type: Number,
        default: 51
      },
    },
    data() {
      return {
        fullName: '',
        email: '',
      }
    },
    methods: {
      openModal() {
        this.$refs.thisModal.open();
        this.getUserInfo();
      },
      getId() {
        return this._uid;
      },
      circleClip(circleCtx, img, width, borderwidth) {
        var center = (width / 2)


        circleCtx.save()
        circleCtx.beginPath()
        circleCtx.arc(center, center, (width / 2) - ((borderwidth * 2) / 2) - 1, 0, Math.PI * 2, false)
        circleCtx.strokeStyle = "#000";
        circleCtx.lineWidth = borderwidth;
        circleCtx.fill();
        circleCtx.stroke()

        circleCtx.save()
        circleCtx.beginPath()
        circleCtx.arc(center, center, (width / 2) - (borderwidth/2) - 1, 0, Math.PI * 2, false)
        circleCtx.strokeStyle = this.bordercolor;
        circleCtx.lineWidth = borderwidth;
        circleCtx.stroke()

        circleCtx.clip()

        circleCtx.drawImage(img, 0, 0, width, width)
        circleCtx.restore()
      },
      getUserInfo() {
        try {
          var url = '/api/Membership/GetSiteUser?username=' + this.username;
          this.$http.get(url).then(async response => {
            var canvas = this.$refs.canvas2;
            this.loadImage(canvas, 171);

            this.fullName = response.data.Name;
            this.email = response.data.Email;
          });
        }
        catch (err) {

        }
      },
      
      loadImage(canvas, size) {
        
        var img = new Image();

        img.src = this.url;

        var thisContext = this;

        img.onload = function () {

          var ctx = canvas.getContext("2d");

          ctx.clearRect(0, 0, size, size);

          ctx.imageSmoothingEnabled = true;

          thisContext.circleClip(ctx, img, size, 5);

        };
      }
    },
    created() {
      
    },
    mounted() {
      var canvas = this.$refs.canvas;
      this.loadImage(canvas, this.size);
    },
    watch: {
      url: function (newVal, oldVal) {
        var canvas = this.$refs.canvas;
        this.loadImage(canvas, this.size);
      },
    },

  }
</script>

<style scoped>
  
</style>



// WEBPACK FOOTER //
// src/components/user/user-detail-button.vue